import React from "react"
import types from "prop-types"
import { useSCIMResourceManagement } from "hooks"
import ItemRow from "shared/ItemRow"

const UserExternalId = ({ user }) => {
  const { usersManagedBySCIM } = useSCIMResourceManagement()

  if (!usersManagedBySCIM) return null

  return (
    <ItemRow
      className="dark"
      itemRowHeaderContent={(
        <>
          <span className="font-bold">External Identifier</span>
          <span>{user.externalIdentifier}</span>
        </>
      )}
    />
  )
}

UserExternalId.propTypes = {
  user: types.object.isRequired,
}

export default UserExternalId
